import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-exam-details-modal-component',
    templateUrl: './exam-details-modal.component.html',
    styleUrls: [],
})
export class ExamDetailsModalComponent {
    @Input() exam: any;
    @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();

    handleClick(): void {
        this.hideModal.emit(true);
    }
}
